<template>
    <form v-if="employee_extended && hasAccess" class="pt-4" @submit.prevent="save">
        <top-nav-bar goto="/?page=profile"></top-nav-bar>
        <h4 class="mb-10 pl-4 text-lg">
            <span class="pb-2 border-b-4 border-blue">Personal Details</span>
        </h4>
        <div class="pb-8">
            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="first_name" :label="trans('crewman::personal.state.first_name')" :required="true">
                        <input type="text" class="input capitalize" v-model="employee_extended.first_name">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="last_name" :label="trans('crewman::personal.state.last_name')" :required="true">
                        <input type="text" class="input capitalize" v-model="employee_extended.last_name">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="nick_name" :label="trans('crewman::personal.state.nick_name')">
                        <input type="text" class="input" v-model="employee_extended.nick_name">
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group :label="trans('crewman::personal.state.date_of_birth')" name="date_of_birth"
                                :required="true">
                        <datepicker v-model="employee_extended.date_of_birth" />
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="age" :label="trans('crewman::personal.state.age')">
                        <input disabled type="text" class="input"
                               :value="formatYears(employee_extended.date_of_birth) || 0">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="gender" :label="trans('crewman::personal.state.gender')" :required="true">
                        <select v-model="employee_extended.gender" id="type" class="input">
                            <option :value="null" disabled>Select a gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                        </select>
                    </form-group>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="citizenship" :label="trans('crewman::personal.state.citizenship')"
                                :required="true">
                        <select v-model="employee_extended.citizenship" id="type" class="input">
                            <option :value="null" disabled>Select a country</option>
                            <option v-for="(country, slug) in countries" :value="country.name">
                                {{ country.name }}
                            </option>
                        </select>
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="nationality" :label="trans('crewman::personal.state.nationality')"
                                :required="true">
                        <select v-model="employee_extended.nationality" id="type" class="input">
                            <option :value="null" disabled>Select a country</option>
                            <option v-for="(country, slug) in countries" :value="country.name">
                                {{ country.name }}
                            </option>
                        </select>
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="marital_status" :label="trans('crewman::personal.state.marital_status')">
                        <select v-model="employee_extended.marital_status" id="type" class="input">
                            <option :value="null" disabled>Select a status</option>
                            <option v-for="(item, slug) in marital_statuses" :value="item.value">
                                {{ item.value }}
                            </option>
                        </select>
                    </form-group>
                </div>
            </div>

            <div v-for="social_number in employee_extended.social_numbers" class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="social_security_number"
                                :label="trans('crewman::personal.state.social_security_number')">
                        <input type="text" class="input" v-model="social_number.social_security_number">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="national_identity_number"
                                :label="trans('crewman::personal.state.national_identity_number')">
                        <input type="text" class="input" v-model="social_number.national_identity_number">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="country" :label="trans('crewman::personal.state.issuing_country')"
                                :required="true">
                        <select v-model="social_number.country.name" id="type" class="input">
                            <option :value="null" disabled>Select a country</option>
                            <option v-for="(country, slug) in countries" :value="country.name">
                                {{ country.name }}
                            </option>
                        </select>
                    </form-group>
                </div>
            </div>

            <div class="block md:inline-flex md:float-right px-4">
                <button class="btn btn--colored__green w-full" type="submit">
                    <i class="fal fa-check"></i>
                    {{ trans('crewman::common.button.save') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'
import InteractsWithDates from '@/mixins/InteractsWithDates'
import NeedsMaritalStatus from '@/mixins/NeedsMaritalStatus'
import CanAccessView from "../mixins/CanAccessView";
import NeedsCountries from "@/mixins/NeedsCountries";

export default {
    mixins: [InteractsWithDates, NeedsMaritalStatus, CanAccessView, NeedsCountries],

    computed: {
        ...mapState(['employee_extended']),
    },

    methods: {
        formatYears(date) {
            return moment().diff(moment(date), 'years');
        },

        save() {
            let data = {
                first_name: this.employee_extended.first_name,
                last_name: this.employee_extended.last_name,
                nick_name: this.employee_extended.nick_name,
                date_of_birth: this.employee_extended.date_of_birth,
                gender: this.employee_extended.gender,
                citizenship: this.employee_extended.citizenship,
                nationality: this.employee_extended.nationality,
                marital_status: this.employee_extended.marital_status,
                social_numbers: this.employee_extended.social_numbers.map((item) => {
                    return {
                        id: item.id || null,
                        social_security_number: item.social_security_number,
                        national_identity_number: item.national_identity_number,
                        country: item.country.name,
                    }
                }),
            }

            this.saving = true;

            this.$api('hr').post('employee/personal', data)
                .then(() => {
                    this.$store.dispatch('fetchEmployeeExtended')
                    this.$noty.success('Updated personal information.')
                    this.saving = false;
                })
                .catch(() => {
                    this.saving = false;
                })
        }
    }
}
</script>
